import {twMerge, twJoin} from "tailwind-merge"

export default {
    install(vue) {
        vue.prototype.$tw = twMerge;
        vue.prototype.$twJoin = twJoin;
    }
}
